import { Pipe, PipeTransform } from '@angular/core';
import { BillingAddress, PaymentMethodInfo } from '@platform-frontend/marketplace';
import { IsPaymentMethodOrBillingAddressDeletablePipe } from './is-payment-method-or-billing-address-deletable.pipe';

@Pipe({
  name: 'isPaymentMethodOrBillingAddressEditable'
})
export class IsPaymentMethodOrBillingAddressEditablePipe extends IsPaymentMethodOrBillingAddressDeletablePipe implements PipeTransform {
  transform(value: PaymentMethodInfo | BillingAddress, updateSubscriptionWithContractId?: string | undefined | null): boolean {
    return (this.isBillingAddress(value) || value.type === 'DIRECT_DEBIT') && super.transform(value, updateSubscriptionWithContractId);
  }

  private isBillingAddress(value: PaymentMethodInfo | BillingAddress): value is BillingAddress {
    return !('type' in value);
  }
}
